import { render, staticRenderFns } from "./SclAdd.vue?vue&type=template&id=31b759d1&scoped=true"
import script from "./SclAdd.vue?vue&type=script&lang=js"
export * from "./SclAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b759d1",
  null
  
)

export default component.exports